// extracted by mini-css-extract-plugin
export default {"taskList":"task-list_taskList__W0Rzw","wrapper":"task-list_wrapper__M8QWf"};